import { commonAxios } from '@/plugins/axios'

const baseURL = '/v1/common/payment/amazon/v2'

export const getSignature = (payload) => commonAxios.post(`${baseURL}/generate-button-signature`, payload)

export const getAmazonCustomerInfo = (sessionId) => commonAxios.get(`${baseURL}/checkout-sessions/${sessionId}`)

export const updateAmazonSession = (sessionId, payload) =>
  commonAxios.patch(`${baseURL}/checkout-sessions/${sessionId}/update`, payload)
